<div class="app-c-input-filed" [ngClass]="customClass">
  <input (input)="onInput($event)" [value]="value" [type]="type" [id]="id" [attr.placeholder]="placeholder"
    [disabled]="disabled" [class.limit-exceeded]="isAtLimit" />
  <ng-content></ng-content>
</div>
<div class="char-count-wrapper" *ngIf="showCharCount && isAtLimit">
  <span class="limit-message">{{ validationMessage }}</span>
</div>
 